module.exports = __webpack_public_path__ + "assets/img/icon-traffic-light.99d6ac8f.png";